module.exports = __webpack_public_path__ + "img/logo-v.8e0b0eaa.png";